import { call, put, takeLatest } from 'redux-saga/effects';

import {
  receiveAPIInfographicsResponse,
  requestAPIFailed,
} from 'src/redux/api/actions';
import { apiCallAsync } from 'src/redux/api/saga';
import {
  INFOGRAPHICS_CREATE,
  INFOGRAPHICS_LOCK,
  INFOGRAPHICS_UNLOCK,
  LOCK_INFOGRAPHICS_ACTION,
  UNLOCK_INFOGRAPHICS_ACTION,
  UPDATE_INFOGRAPHICS_ACTION,
} from 'src/redux/constants';
import type { ViewAction } from 'src/redux/viewState/types';
import { getActionAPISource } from 'src/utils';
import { UnlockInfographicsActionSuccess } from './actions';

export function* updateInfographicsSaga(action: ViewAction) {
  try {
    const url = getActionAPISource(INFOGRAPHICS_CREATE);
    const res = yield call(
      apiCallAsync,
      url,
      action.value?.value?.data,
      'post',
    );
    if (res.status === 200) {
      yield put(receiveAPIInfographicsResponse(action.dataKey, res.data));
    } else {
      throw 'API call has failed';
    }
  } catch (e) {
    yield put(requestAPIFailed(action.dataKey, e.toString()));
    console.error(e);
  }
}

export function* lockInfographicsSaga(action: ViewAction) {
  try {
    const url = getActionAPISource(INFOGRAPHICS_LOCK);
    yield call(apiCallAsync, url, action.value?.value?.data, 'post');
  } catch (e) {
    yield put(requestAPIFailed(action.dataKey, e.toString()));
    console.error(e);
  }
}

export function* unlockInfographicsSaga(action: ViewAction) {
  try {
    const url = getActionAPISource(INFOGRAPHICS_UNLOCK);
    const res = yield call(
      apiCallAsync,
      url,
      action.value?.value?.data,
      'post',
    );
    yield put(UnlockInfographicsActionSuccess(res.data.infographics_editor));
  } catch (e) {
    yield put(requestAPIFailed(action.dataKey, e.toString()));
    console.error(e);
  }
}

export function* watchUpdateInfographicsSaga() {
  yield takeLatest(UPDATE_INFOGRAPHICS_ACTION, updateInfographicsSaga);
}

export function* watchLockInfographicsSaga() {
  yield takeLatest(LOCK_INFOGRAPHICS_ACTION, lockInfographicsSaga);
}

export function* watchUnlockInfographicsSaga() {
  yield takeLatest(UNLOCK_INFOGRAPHICS_ACTION, unlockInfographicsSaga);
}
